import { useEffect, useState } from "react";
import jwtDecode from "jwt-decode";
import axios from "axios";
import { CSVLink } from "react-csv";

import { useAuth } from "./AuthProvider";
import { api } from "../../constants";

type Progress = {
  fail: number;
  msg: string;
  remain: number;
  status: number;
  success: number;
  data?: any[];
} | null;

const UploadResults = ({ results }: { results: any }) => {
  const [progress, setProgress] = useState<Progress>();

  const { token } = useAuth();

  useEffect(() => {
    let timeoutId: any = 0;
    if (results?.progress_url) {
      if (!token) return;

      const access_token: any = (jwtDecode(token) as any).user.access_token;

      timeoutId = setInterval(async () => {
        const resp = await axios.post(api, {
          token: access_token,
          cmd: "ModHandle.getSignUpProgress",
          sign: results.sign,
        });

        console.log("resp.data", resp.data);

        setProgress(resp.data);

        if (resp.data?.data) {
          clearInterval(timeoutId);
        }
      }, 2000);
    }

    return () => clearInterval(timeoutId);
  }, [results?.progress_url]);

  const fail = progress?.fail || 0;
  const success = progress?.success || 0;
  const remain = progress?.remain || 0;

  const percentage = (
    ((fail + success) / (fail + success + remain)) *
    100
  ).toFixed(2);

  return (
    <div style={{ margin: "30px 20px 40px 20px" }}>
      <div>
        <h2>Please wait, we are generating users.</h2>

        <div className="mt-6">
          <h2>Progress: {Number.isNaN(+percentage) ? 0 : percentage}%</h2>
        </div>

        <div className="flex flex-row text-center justify-around mt-6">
          <h2>
            Accounts created:{" "}
            <span className=" text-green-600">{progress?.success}</span>
          </h2>
          <h2>
            Accounts failed:{" "}
            <span className=" text-red-600"> {progress?.fail}</span>
          </h2>
        </div>

        {progress?.data && (
          <div className="mt-12">
            <CSVLink
              style={{ fontSize: 30 }}
              title={"Registration Results"}
              filename={"Registration Results"}
              data={progress.data}
            >
              Download me
            </CSVLink>
          </div>
        )}
      </div>
    </div>
  );
};

export default UploadResults;
